import { Sparkles } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

const MAX = 1500;

interface Props {
  value: string;
  onChange: (v: string) => void;
  optimize: boolean;
  onOptimizeChange: (v: boolean) => void;
}

// PromptBox — the Hero of FreeView (Lumi P3 redesign) + opt-in optimize.
//   bg-card-elev        : surface 2, visually heavier than the surrounding panel
//   shadow-prompt-hero  : resting elevation — soft warm halo, inset highlight
//   shadow-prompt-focus : focus elevation — accent ring + outer glow
// The textarea sits on a transparent fill so the hero surface owns the visual
// identity. Optimization is server-side at submit time when the checkbox is
// ticked; it preserves the input language and the rewritten text is never
// shown back to the user (see prompt_optimizer.mjs).
export function PromptBox({ value, onChange, optimize, onOptimizeChange }: Props) {
  return (
    <div
      className="
        flex flex-col gap-3 rounded-lg border border-border bg-card-elev px-5 py-4
        shadow-prompt-hero transition-shadow duration-200
        focus-within:shadow-prompt-focus focus-within:border-accent/60
      "
    >
      <Textarea
        rows={6}
        placeholder={"描述你想要的图…\n例：一只戴墨镜的柯基坐在赛博朋克天台"}
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, MAX))}
        className="
          t-body-lg min-h-[148px] resize-none border-0 bg-transparent p-0
          placeholder:text-muted-foreground/60
          focus-visible:border-0 focus-visible:ring-0 focus-visible:ring-offset-0
        "
      />
      <div className="flex flex-wrap items-center gap-3">
        <Checkbox
          checked={optimize}
          onChange={(e) => onOptimizeChange(e.target.checked)}
          className="text-xs text-muted-foreground hover:text-foreground"
          label={
            <span className="inline-flex items-center gap-1.5">
              <Sparkles className="h-3.5 w-3.5 text-accent" />
              AI 优化提示词（提交时自动应用，不改变你的语言）
            </span>
          }
        />
        <span className="t-mono ml-auto text-muted-foreground/70">
          {value.length} / {MAX}
        </span>
      </div>
    </div>
  );
}
